import { Injectable } from '@angular/core';
import { DeviceId, DeviceInfo } from '@capacitor/device';
import { from, Observable } from 'rxjs';
import { DeviceWrapper } from 'src/app/wrappers/device.wrapper';
import { mapDeviceInfoPlatformToMSPlatform, MSDeviceInfo } from './utils/device.utils';

@Injectable({
  providedIn: 'root'
})
export class DeviceAdapter {
  constructor(private deviceWrapper: DeviceWrapper) {}

  getDeviceInfo(): Observable<MSDeviceInfo> {
    const deviceInfoPromise = new Promise<MSDeviceInfo>(async (resolve) => {
      const deviceId: DeviceId = await this.deviceWrapper.getDeviceId();
      const deviceInfo: DeviceInfo = await this.deviceWrapper.getDeviceInfo();
      const platform = deviceInfo.platform;
      const msPlatform = mapDeviceInfoPlatformToMSPlatform(platform);
      const msDeviceInfo: MSDeviceInfo = {
        uuid: deviceId.identifier,
        platform: msPlatform,
        version: deviceInfo.osVersion,
        model: deviceInfo.model,

        manufacturer: deviceInfo.manufacturer,
        isVirtual: deviceInfo.isVirtual
      };

      resolve(msDeviceInfo);
    });

    const deviceInfoObservable = from(deviceInfoPromise);
    return deviceInfoObservable;
  }
}
